import { createFileRoute, redirect } from '@tanstack/react-router';
import { inviteAutoAcceptIntent } from '@/features/invites/utils/autoAcceptIntent';
import { getPendingInvites } from '@/features/settings/user-management/api/invitesApi';

export const Route = createFileRoute('/(app)/')({
  loader: async ({ context }) => {
    if (inviteAutoAcceptIntent.peek()) {
      throw redirect({ to: '/invites/auto-accept' });
    }

    const { organizationName } = context;
    if (!organizationName) {
      throw redirect({ to: '/' });
    }

    let hasPendingInvites = false;
    try {
      const { invites } = await getPendingInvites();
      hasPendingInvites = invites.length > 0;
    } catch {
      // Invite lookup failure shouldn't block the org redirect below
    }

    if (hasPendingInvites) {
      throw redirect({ to: '/invites' });
    }

    throw redirect({
      to: '/org/$org',
      params: { org: organizationName },
    });
  },
});
